import { ApiService, AuthService } from '@ibe/services';

class Service {
  protected readonly ERR_NO_API = 'Can not init booking: No API instance.';

  protected readonly ERR_NO_AUTHORIZATION_SERVICE = 'No authorization instance.';

  protected api: ApiService | null = null;

  protected authService: AuthService | null = null;

  setApi(api: ApiService): void {
    this.api = api;
  }

  setAuth(auth: AuthService): void {
    this.authService = auth;
  }
}

export default Service;
